import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {WorkerCountDivergenceNote} from '@/components/worker-count-divergence-note'
import {WorkerCountDialog} from '@/components/worker-count-dialog'
import {chapterNoteFor} from './chapter-note'
import {useRederiveAssessment, type SgsstState} from '@/hooks/sgsst/evaluacion/use-sgsst'
import {translateApiError} from '@/lib/errors'

export function WorkerDivergenceBanner({
  businessId,
  state,
  editable,
}: {
  businessId: string
  state: SgsstState
  editable: boolean
}) {
  const {t} = useTranslation()
  const assessment = state.assessment!
  const activeCount = state.active_employee_count
  const rederive = useRederiveAssessment(businessId)
  const [editing, setEditing] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const chapterNote = chapterNoteFor(state.risk_class, assessment.chapter, t)
  if (assessment.worker_count === activeCount) return null
  return (
    <>
      <WorkerCountDivergenceNote
        businessId={businessId}
        declared={assessment.worker_count}
        active={activeCount}
        editable={editable}
        onUpdateDeclared={() => {
          setError(null)
          setEditing(true)
        }}
      />
      <WorkerCountDialog
        open={editing}
        onOpenChange={setEditing}
        title={t('workerCount.sgsstDialogTitle')}
        description={t('workerCount.sgsstDialogBody')}
        initial={assessment.worker_count}
        pending={rederive.isPending}
        error={error}
        note={chapterNote}
        onSave={(count) =>
          rederive.mutate(count, {
            onSuccess: () => setEditing(false),
            onError: (err) => setError(translateApiError(err)),
          })
        }
      />
    </>
  )
}
